/**
 * Dashboard translations index - combines all dashboard modules
 */

import {
  nav,
  emailVerification,
  handleVerification,
  impersonation,
  account,
  loading,
  empty,
  sepa,
  invoice,
  dashboardCommon
} from './core'
import { domains, domain, delegation } from './domains'
import { email, shop, packet, kubernetes } from './services'
import { admin } from './admin'
import { home } from './home'
import { mail } from './mail'
import { storage } from './storage'
import { subAccounts } from './subAccounts'
import { registry } from './registry'
import { hosting } from './hosting'
import { vserver } from './vserver'

const dashboard = {
  nav,
  emailVerification,
  handleVerification,
  impersonation,
  account,
  loading,
  empty,
  sepa,
  invoice,
  common: dashboardCommon,
  domains,
  domain,
  delegation,
  email,
  shop,
  packet,
  kubernetes,
  admin,
  home,
  mail,
  storage,
  registry,
  hosting,
  vserver,
  subAccounts
} as const

export default dashboard
